import $ = require('jquery');
import moduleSelector from 'diy/site-admin/module-selector/moduleSelector';
let siteAdminApi = require<any>('diy/site-admin/main/api');
import Modul from '../../Modul';

//TODO: Replace with Modul.getInstance()
declare var mm: {
    [moduleId: string]: Modul;
};

/** @deprecated Use Matrix.getInstance() instead */
declare var matrix: {
    [matrixId: string]: Matrix;
};

/**
 * Matrix
 */
export default class Matrix {
    static getMainContentMatrixEl: () => JQuery;

    /**
     * jQuery object holding the div with the id: #matrix_<matrixId>.
     */
    matrix: JQuery = null;

    matrixId: number = null;
    pageId: number;

    trigger: any; // this doesn't appear to be used, but can't be sure
    private warningVeil: JQuery;

    static getInstance(matrixId: number|string) {
        return matrix[matrixId];
    }

    constructor(matrixId: number) {
        this.matrix = $('#matrix_' + matrixId);
        this.matrixId = matrixId;
        this.pageId = parseInt($("body").attr("data-pageid"), 10);
    }

    /**
     * Returns all divs representing a module.
     *
     * Returns: jQuery collection.
     */
    getModules() {
        return this.matrix.find("> div[id^='modul']");
    }

    /**
     * Callback for the deletion confirmation button.
     */
    del(childId: number, moduleId: number) {
        let self = this;
        let moduleObj = mm[moduleId];
        let postData: any = {};
        // prevent cancelEdit from beeing called

        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'delete-module',
            propName: (moduleObj instanceof Modul) ? moduleObj.moduleType : 'moduleWithError'
        });

        postData = {
            'matrixID' : self.matrixId,
            'childID' : childId,
            'moduleId' : moduleId,
            'pageId' : this.pageId,
            'action' : 'del'
        };

        if ((moduleObj instanceof Modul) && moduleObj.getIsNew()) {
            postData._diyNewlyAdded = 1;
        }

        // close current module if open !!! DO NOT MOVE THIS BLOCK ABOVE moduleObj.close will reset newlt added
        if (moduleObj instanceof Modul) {
            if (moduleObj.getIsInEditMode()) {
                // we close the module, but do not cancel edit now
                moduleObj.close(false, false);
            }
            moduleObj.hide();
            // close all other active modules
            Modul.abortEditingModules(moduleId);
        }

        $.ajax({
            url : systemurl + 'app/module/module/del',
            data : postData,
            type : 'POST',
            dataType : 'json',
            success : function(data) {
                if (data.ok) {
                    let webcomponentId: string;
                    if (!(mm[moduleId] instanceof Modul)) {
                        let moduleErrEl = $('#modul_' + moduleId + '_error');
                        webcomponentId = moduleErrEl.attr('data-webcomponentId');
                        moduleErrEl.remove();
                    } else {
                        let moduleEl = mm[moduleId].getModuleElement();
                        webcomponentId = moduleEl.attr('data-webcomponentId');

                        renderWeight -= data.renderWeight;

                        if (!data.hasReachedCriticalLimit && $("#cc-sa-sidebar").hasClass("modules-critical")) {
                            siteAdminApi.destroyController('cc-sa-item-elements');
                            $("#cc-sa-sidebar").removeClass("modules-critical");
                        }

                        if (!data.hasReachedMaximumLimit && $("#cc-sa-sidebar").hasClass("modules-maximum")) {
                            siteAdminApi.destroyController('cc-sa-item-elements');
                            $("#cc-sa-sidebar").removeClass("modules-maximum");
                        }

                        moduleSelector.setLimitCallout();

                        mm[moduleId].remove();

                        if (data.postActions) {
                            for (let key in data.postActions) {
                                if (data.postActions.hasOwnProperty(key)) {
                                mm[moduleId].postAction(data.postActions[key]);
                            }
                        }
                        }
                        mm[moduleId].onDelete();
                        delete mm[moduleId];
                    }
                    if (webcomponentId) {
                        let wpm = jimdoData.webcomponentsPerMatrix;
                        wpm[self.matrixId][webcomponentId] =
                            parseInt(wpm[self.matrixId][webcomponentId] as any, 10) - 1;
                    }

                    $(document).trigger('diy-editor-module-deleted');
                } else {
                    if (mm[moduleId] instanceof Modul) {
                        mm[moduleId].getDeleteBtn().button({disabled: false});
                        mm[moduleId].show();
                    }
                    let message = data.msg;

                    let htmlMsg = '<div class="error" id="error_' + moduleId +
                        '" style="border: 1px solid #c00; background: pink; padding: 10px; margin: 0 5px 10px;">' +
                        message +
                    '</div>';

                    //transform the loading sign into an error message
                    if ($('#modul_' + moduleId).prev().hasClass("error")) {
                        $('#modul_' + moduleId).prev().show();
                        $('#modul_' + moduleId).prev().html(message);
                    } else {
                        $('#modul_' + moduleId).before(htmlMsg);
                    }

                    window.setTimeout(function() {
                        $('#error_' + moduleId).fadeOut(500);
                    }, 4000);
                }
            },
            error: function() {
                if (mm[moduleId] instanceof Modul) {
                    mm[moduleId].getDeleteBtn().button({disabled: false});
                    mm[moduleId].hideLoading();
                }
            }
        });

        return;
    }

    deleteModule(moduleId: number, scrollToIt: boolean, triggerEvent: boolean) {
        let webcomponentId: string;

        if (!(mm[moduleId] instanceof Modul)) {
            let moduleErrEl = $('#modul_' + moduleId + '_error');
            webcomponentId = moduleErrEl.attr('data-webcomponentId');
            moduleErrEl.remove();
        } else {
            let moduleEl = mm[moduleId].getModuleElement();
            webcomponentId = moduleEl.attr('data-webcomponentId');

            if (scrollToIt) {
                mm[moduleId].getContentContainer().scrollIntoView();
            }

            $(mm[moduleId].modul).fadeOut(500);
            mm[moduleId].remove();

            // if the module has an onDelete method defined, run it
            if (mm[moduleId].onDelete) {
                mm[moduleId].onDelete();
            }
            delete mm[moduleId];
        }

        if (webcomponentId) {
            let wpm = jimdoData.webcomponentsPerMatrix;
            wpm[this.matrixId][webcomponentId] = parseInt(wpm[this.matrixId][webcomponentId] as any, 10) - 1;
        }

        if (triggerEvent !== false) {
            $(document).trigger('diy-editor-module-deleteFinished');
        }
    }

    addModule(moduleId: number, cmsView: string, editView: string, afterChildId: number, scrollToIt: boolean) {
        let afterEl: JQuery = $();

        if (afterChildId > 0) {
            afterEl = this.matrix.find('[data-matrixchildid=' + afterChildId + ']');
        }

        if (afterEl.length) {
            $(cmsView).insertAfter(afterEl);
        } else {
            $(cmsView).prependTo(this.matrix);
        }
        $(editView).appendTo('body');

        let module = mm[moduleId];
        let moduleEl = module.getModuleElement();
        let webcomponentId = moduleEl.attr('data-webcomponentId');

        if (webcomponentId !== undefined) {
            let wpm = jimdoData.webcomponentsPerMatrix;

            if (!wpm[this.matrixId]) {
                wpm[this.matrixId] = {};
            }
            if (!wpm[this.matrixId][webcomponentId]) {
                wpm[this.matrixId][webcomponentId] = 0;
            }
            wpm[this.matrixId][webcomponentId] = parseInt(wpm[this.matrixId][webcomponentId] as any, 10) + 1;
        }

        if (this.trigger instanceof Function) {
            this.trigger('onload', this);
        }

        if (scrollToIt) {
            module.getContentContainer().scrollIntoView();
        }

        $(document).trigger('diy-editor-module-addFinished');
    }

    getChildModule(childId: number) {
        let childModuleId = this.getChildModuleEl(childId).attr('data-moduleid');
        return childModuleId ? mm[childModuleId] : null;
    }

    getChildModuleEl(childId: number) {
        return this.matrix.find('[data-matrixchildid=' + childId + ']');
    }

    showWarningVeil() {
        if (!this.warningVeil) {
            let warningVeil = '';
            warningVeil += '<div class="diye-warning-veil">' +
                           '<div class="diye-warning-veil-border">' +
                           '<div class="diye-warning-veil-innerborder">&nbsp;</div>' +
                           '</div></div>';

            this.warningVeil = $(warningVeil);
            this.matrix.append(this.warningVeil);
        }
        this.warningVeil.show();
    }
    hideWarningVeil() {
        if (this.warningVeil) {
            this.warningVeil.hide();
        }
    }
    supportsDragging() {
        /* at the moment, only content zones support dragging.
        Matrix modules do not */
        return this.matrix.hasClass('sortable-matrix');
    }
}

/* Store the main content matrix since we're going to access it a lot */
let $mainMatrixEl: JQuery = null;

/**
 * Returns the widest matrix element on the page
 */
Matrix.getMainContentMatrixEl = function() {
    if ($mainMatrixEl) {
        return $mainMatrixEl;
    }

    let maxWidthMatrix = 0;
    let $theMatrix: JQuery = null;

    $('[data-matrixid]').each((index, el) => {
        let $el = $(el);
        let width = $el.width();
        if (maxWidthMatrix < width) {
            maxWidthMatrix = width;
            $theMatrix = $el;
        }
    });

    return $mainMatrixEl = $theMatrix;
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/Matrix.ts
 **/